import { render, staticRenderFns } from "./planoMensalInfantil.vue?vue&type=template&id=07596052"
import script from "./planoMensalInfantil.vue?vue&type=script&lang=js"
export * from "./planoMensalInfantil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports